import { RoleTypeEnum } from "../../../../services";

type PRIVIALGE_TYPE_OPTION = {
  value: string;
  label: string;
};

export const PREVILLAGES_LIST: PRIVIALGE_TYPE_OPTION[] = [
  {
    value: "PATIENT_MANAGEMENT",
    label: "Patient Management",
  },
  { value: "PATIENT_CHART", label: "Patient Chart" },
  { value: "SCHEDULING", label: "Scheduling" },
  { value: "ENCOUNTER", label: "Visit" },
  {
    value: "PATIENT_ENGAGEMENT",
    label: "Patient Engagement",
  },
  { value: "LIBRARY", label: "Library" },
  { value: "AI_SCRIBER", label: "AI Scriber" },
  { value: "SETTINGS", label: "Settings" },
  { value: "BILLING", label: "Billing" },
  { value: "TASK_MANAGEMENT", label: "Task Management" },
  {
    value: "EDUCATION_MATERIAL_MANAGEMENT",
    label: "Education Material Management",
  },
];

export type RoleType = "staff" | "provider" | "admin";

type RoleOption = {
  label: string;
  value: RoleTypeEnum | "SUPPORT" | "SUPERVISING_MD";
};
//provider roles
// Care Manager	Provider
// Physician	Provider
// Practice Admin	Provider
// Billing Admin	Provider
// Biller	Provider

const PROVIDER_ROLES: RoleOption[] = [
  {
    value: "CARE_MANAGER",
    label: "Care Manager",
  },
  {
    value: "PHYSICIAN",
    label: "Physician",
  },
  {
    value: "PRACTICE_ADMIN",
    label: "Practice Admin",
  },
  {
    value: "BILLING_ADMIN",
    label: "Billing Admin",
  },
  {
    value: "BILLER",
    label: "Biller",
  },
  {
    value: "SUPERVISING_MD",
    label: "Supervising MD",
  },
];

//staff roles
// Front desk/Staff	Staff
// Sales coordinator	Staff
// Support	Staff
const STAFF_ROLES: RoleOption[] = [
  {
    value: "FRONT_DESK_STAFF",
    label: "Front desk/Staff",
  },
  {
    value: "SALES_COORDINATOR",
    label: "Sales coordinator",
  },
  // todo : backend support role is not yet implemented
  {
    value: "SUPPORT",
    label: "Support",
  },
];

export const SELECT_ROLE_OPTIONS: Record<RoleType, RoleOption[]> = {
  staff: STAFF_ROLES,
  provider: PROVIDER_ROLES,
  admin: [...PROVIDER_ROLES, ...STAFF_ROLES],
};

// export const RoleTypeEnum = {
//   Admin: 'ADMIN',
//   Staff: 'STAFF',
//   Patient: 'PATIENT',
//   Provider: 'PROVIDER',
//   Physician: 'PHYSICIAN',
//   BillingAdmin: 'BILLING_ADMIN',
//   Biller: 'BILLER',
//   FrontDeskStaff: 'FRONT_DESK_STAFF',
//   SalesCoordinator: 'SALES_COORDINATOR',
//   PracticeAdmin: 'PRACTICE_ADMIN',
//   CareManager: 'CARE_MANAGER'
// } as const;
